import { PrimaryButton, QuantityCounter, Space, SubText } from '@procurify/ui'

import { Price } from '@webapp/core/components/Price'
import { type CurrencyName } from '@webapp/core/entities/external/Currency/CurrencyName'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export interface ICatalogItemDetailsCartProps {
  quantity: number
  estimatedTotal: number
  currency: CurrencyName
  onQuantityChange: (quantity: number) => void
  onAddToRequest: () => void
}

export const CatalogItemDetailsCart = ({
  quantity,
  estimatedTotal,
  currency,
  onQuantityChange,
  onAddToRequest,
}: ICatalogItemDetailsCartProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space direction='vertical' size='small'>
      <Space direction='horizontal' justify='space-between' align='center'>
        <QuantityCounter
          value={quantity}
          onChange={onQuantityChange}
          aria-label={intl.formatMessage(messages.quantityAriaLabel)}
        />
        <Space direction='horizontal' size='small' align='baseline'>
          <SubText>{intl.formatMessage(messages.estimatedTotal)}</SubText>
          <span className='fs-mask'>
            <Price inline price={estimatedTotal} currency={currency} />
          </span>
        </Space>
      </Space>
      <PrimaryButton
        fullWidth
        analyticsId='catalog-item-details-add-to-request-button'
        onClick={onAddToRequest}
      >
        {intl.formatMessage(messages.addToRequestButton)}
      </PrimaryButton>
    </Space>
  )
}
